import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { mappedTransitionTransformProperties, TraitRegistryCssTransition, transitionProperties } from './TraitRegistryCssTransition';
import { TraitRegistryCssBackground } from './TraitRegistryCssBackground';
import { TraitRegistryCssBlock } from './TraitRegistryCssBlock';
import { TraitRegistryCssBox } from './TraitRegistryCssBox';
import { TraitRegistryCssDisplay } from './TraitRegistryCssDisplay';
import { TraitRegistryCssFlex } from './TraitRegistryCssFlex';
import { TraitRegistryCssFont } from './TraitRegistryCssFont';
import { TraitRegistryCssTransform } from './TraitRegistryCssTransform';
import { TraitRegistryCssEffects } from './TraitRegistryCssEffects';
import { transitionProp } from '../TraitRegistry';
import { TraitRegistryCssAnimation } from './TraitRegistryCssAnimation';
import { TraitRegistryCssSvg } from './TraitRegistryCssSvg';
import { TraitRegistryCssTable } from './TraitRegistryCssTable';
import { createsTrait, traitCreatedBy } from '../TraitRegistryDependencies';
import { configTrait } from '../ConfigTrait';
export class TraitRegistryCss extends TraitRegistryCategory {
    label = 'CSS';
    c_tr = new TraitRegistryCssTransition(this);
    c_bg = new TraitRegistryCssBackground(this);
    c_bk = new TraitRegistryCssBlock(this);
    c_bx = new TraitRegistryCssBox(this);
    c_di = new TraitRegistryCssDisplay(this);
    c_fx = new TraitRegistryCssFlex(this);
    c_ft = new TraitRegistryCssFont(this);
    c_tf = new TraitRegistryCssTransform(this);
    c_eff = new TraitRegistryCssEffects(this);
    c_an = new TraitRegistryCssAnimation(this);
    c_svg = new TraitRegistryCssSvg(this);
    c_tb = new TraitRegistryCssTable(this);
    cssKeys = [];
    constructor(parent) {
        super(parent);
        this.cssKeys = this.allLeafKeys;
        this.addDependencies();
    }
    addDependencies() {
        for (const key of configTrait.scaleProperties) {
            createsTrait[key] = [...(createsTrait[key] || []), `scale_${key}`];
            traitCreatedBy[`scale_${key}`] = [...(traitCreatedBy[`scale_${key}`] || []), key];
        }
        const allTransitionProperties = [...transitionProperties, ...mappedTransitionTransformProperties];
        for (const key of allTransitionProperties) {
            const tProp = transitionProp(key);
            if (transitionProperties.includes(tProp)) {
                createsTrait[key] = [...(createsTrait[key] || []), `transition_${tProp}`];
                traitCreatedBy[`transition_${tProp}`] = [...(traitCreatedBy[`transition_${tProp}`] || []), key];
            }
        }
    }
    addScaleAndTransition(r) {
        const transitionFacet = transitionProp(r.key);
        if (!r.css) {
            r.css = this.defaultCssFunction;
        }
        if (configTrait.scaleProperties.includes(r.key)) {
            r.aspectsTemplate = r.aspectsTemplate || { core: [] };
            r.aspectsTemplate.core.push(`scale_${r.key}`);
        }
        if (transitionProperties.includes(transitionFacet)) {
            if (!r.aspectsTemplate)
                r.aspectsTemplate = {};
            if (!r.aspectsTemplate.core)
                r.aspectsTemplate.core = [];
            r.aspectsTemplate.core.push(`transition_${transitionFacet}`);
        }
    }
    defaultCssFunction({ at }) {
        const cssPairs = [];
        if (configTrait.scaleProperties.includes(at.key)) {
            cssPairs.push({ k: at.key, v: at.scaledValue });
            return cssPairs;
        }
        if (['string', 'number'].includes(typeof at.attachedValue)) {
            cssPairs.push({ k: at.key, v: at.attachedValue });
            return cssPairs;
        }
        return cssPairs;
    }
}
